let initialState = {
}

export const reducer = (state = initialState, action) => {
    switch(action.type){
        case 'ADD_THERAPY_TYPE': return {...state, therapyType: action.payload};
        case 'ADD_PROBLEM': return {...state, problems: action.payload};
        case 'SELECT_GENDER': return {...state, gender: action.payload};
        case 'SET_AGE': return {...state, age: action.payload};
        default: return state;
    }
}